export const NOM_APPLICATION = {
    KANIS_LOGISTICS_CI: 'KANIS LOGISTICS CI',
} as const;

export type T_NOM_APPLICATION =
    typeof NOM_APPLICATION[keyof typeof NOM_APPLICATION];
